<div class="custom-snackbar">
  @switch (data.type) {
    @case ('success') {
      <mat-icon>done</mat-icon>
    }
    @case ('error') {
      <mat-icon>error_outline</mat-icon>
    }
    @case ('warning') {
      <mat-icon>warning</mat-icon>
    }
    @case ('info') {
      <mat-icon>info</mat-icon>
    }
  }
  <span class="mx-3">{{ data.message }}</span>
  <button mat-icon-button class="ms-auto" (click)="close()">
    <mat-icon>clear</mat-icon>
  </button>
</div>
